import React from 'react';

import { PermissionGuard } from '~/core/PermissionGuard';
import { permissions as accountingIntegrationsPermissions } from '~/core/routes/settings/accounting-integrations/_index';
import { permissions as assignmentStrategyPermissions } from '~/core/routes/settings/assignment-strategy/Router';
import { permissions as bankAccountsPermissions } from '~/core/routes/settings/bank-accounts/_index';
import { permissions as bankIntegrationsPermissions } from '~/core/routes/settings/bank-integrations/_index';
import { permissions as creditFacilitiesPermissions } from '~/core/routes/settings/credit-facilities/permissions';
import { permissions as fundingRequestPermissions } from '~/core/routes/settings/funding-requests/permissions';
import { permissions as notificationsPermissions } from '~/core/routes/settings/notifications/_index';
import { permissions as webhooksPermissions } from '~/core/routes/settings/webhooks/_index';
import { Icon } from '~/packages/common-frontend/components/icons';
import {
  GlobalNav,
  GlobalNavRouterLinkItem,
} from '~/packages/common-frontend/layout';

export const SettingsGlobalNav = ({
  isFixed = true,
}: {
  isFixed?: boolean;
}) => {
  return (
    <GlobalNav isFixed={isFixed}>
      <GlobalNavRouterLinkItem
        to="/"
        end
        label="Home"
        icon={<Icon icon="home" />}
      />

      {/* Common settings (borrower + capProvider + valleyBank) */}
      <GlobalNavRouterLinkItem
        to="/settings/my-account"
        label="User Information"
        icon={<Icon icon="user" />}
      />

      {/* Credit Facility & Credit Agreement Settings */}
      <PermissionGuard permissions={creditFacilitiesPermissions}>
        <GlobalNavRouterLinkItem
          to="/settings/credit-facilities"
          label="Facilities"
          icon={<Icon icon="building-columns" />}
        />
      </PermissionGuard>

      {/* Borrower settings */}
      <PermissionGuard permissions={bankAccountsPermissions}>
        <GlobalNavRouterLinkItem
          to="/settings/bank-accounts"
          label="Bank Accounts"
          icon={<Icon icon="wallet" />}
        />
      </PermissionGuard>

      <PermissionGuard permissions={bankIntegrationsPermissions}>
        <GlobalNavRouterLinkItem
          to="/settings/bank-integrations"
          label="Bank Integrations"
          icon={<Icon icon="link" />}
        />
      </PermissionGuard>

      <PermissionGuard permissions={accountingIntegrationsPermissions}>
        <GlobalNavRouterLinkItem
          to="/settings/accounting-integrations"
          label="Accounting Integrations"
          icon={<Icon icon="calculator" />}
        />
      </PermissionGuard>

      <PermissionGuard permissions={notificationsPermissions}>
        <GlobalNavRouterLinkItem
          to="/settings/notifications"
          label="Notifications"
          icon={<Icon icon="mailbox-flag-up" />}
        />
      </PermissionGuard>

      <PermissionGuard permissions={webhooksPermissions}>
        <GlobalNavRouterLinkItem
          to="/settings/webhooks"
          label="Webhooks"
          icon={<Icon icon="code" />}
        />
      </PermissionGuard>

      <PermissionGuard permissions={assignmentStrategyPermissions}>
        <GlobalNavRouterLinkItem
          to="/settings/assignment-strategy"
          label="Assignment Strategy"
          icon={<Icon icon="sliders" />}
        />
      </PermissionGuard>

      {/* Funding Request settings */}
      <PermissionGuard permissions={fundingRequestPermissions}>
        <GlobalNavRouterLinkItem
          to="/settings/funding-requests"
          label="Funding Requests"
          icon={<Icon icon="dollar-sign" />}
        />
      </PermissionGuard>
    </GlobalNav>
  );
};
